import gql from "graphql-tag";
import UserSettings from "lib/fragments/UserSettings";

export default gql`
  mutation ToggleBookmarkForIndicator($indicator: ValuationIndicator!) {
    toggleBookmarkForIndicator(input: $indicator) {
      _id
      ...UserSettings
    }
  }

  ${UserSettings}
`;
